import { isDefined } from "@clipboard-health/util-ts";
import { useWorkerPreferences } from "@src/appV2/Agents/api/useWorkerPreferences";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";

import { useInHomeStatistics } from "./useInHomeStatistics";
import { useIsInHomeEnabled } from "./useIsInHomeEnabled";

export function useInHomeVisibility() {
  const isInHomeEnabled = useIsInHomeEnabled();
  const worker = useDefinedWorker();
  const { filters } = useWorkerPreferences();
  const workerGeoLocation = useWorkerGeoLocation();

  const { data: inHomeStatistics, isLoading } = useInHomeStatistics(
    {
      filter: {
        longitude: workerGeoLocation?.longitude,
        latitude: workerGeoLocation?.latitude,
        maxDistanceInMiles: filters?.distance,
        qualifications: worker.licensesData.map((license) => license.qualification).join(","),
      },
    },
    worker.userId,
    {
      enabled:
        isDefined(filters) &&
        isDefined(workerGeoLocation) &&
        isInHomeEnabled &&
        worker.licensesData.length > 0,
    }
  );

  const { openVisitsCount, bookedVisits } = inHomeStatistics?.data?.attributes ?? {};

  return {
    isInHomeEnabled,
    inHomeCount: openVisitsCount,
    isInHomeLoading: isLoading,
    bookedVisits,
  };
}
